import {StringValue, Value} from '@ng-app-framework/core';
import * as qs from 'qs';
export class RequestBuilder {
/**
 * @param {?} method
 * @param {?} url
 * @param {?} data
 * @return {?}
 */
static getRequestArgs(method: string, url: string, data: { [key: string]: any }): any {
        if (method === 'get' || method === 'delete') {
            return this.getQueryStringRequest(method, url, data);
        }
        return this.getBodyRequest(method, url, data);
    }
/**
 * @param {?} method
 * @param {?} url
 * @param {?} data
 * @return {?}
 */
static getBodyRequest(method: string, url: string, data: { [key: string]: any }) {
        return {
            method: method,
            url   : this.populateValuesInUrl(url, data),
            body  : data
        };
    }
/**
 * @param {?} method
 * @param {?} url
 * @param {?} data
 * @return {?}
 */
static getQueryStringRequest(method: string, url: string, data: { [key: string]: any }) {
        let /** @type {?} */ fullUrl = this.populateValuesInUrl(url, data);
        return {
            method: method,
            url   : RequestBuilder.getUrlWithQueryParameters(fullUrl, data)
        };
    }
/**
 * @param {?} url
 * @param {?} data
 * @return {?}
 */
static getUrlWithQueryParameters(url: string, data: { [key: string]: any }): string {
        let /** @type {?} */ queryStringData = qs.stringify(data);
        if (queryStringData.length > 0) {
            let /** @type {?} */ delimiter = '?';
            if (url.indexOf('?') !== -1) {
                delimiter = '&';
            }
            return url + delimiter + queryStringData;
        }
        return url;
    }
/**
 * @param {?} url
 * @param {?} data
 * @return {?}
 */
static populateValuesInUrl(url: string, data: { [key: string]: any }): string {
        let /** @type {?} */ formatted = url;
        for (let /** @type {?} */ key in data) {
            if (Value.isScalar(data[key]) && key.indexOf(':') === 0) {
                formatted = StringValue.replace(formatted, `${key}`, data[key].toString());
                delete data[key];
            }
        }
        return formatted;
    }
}
